import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { PropType } from 'vue'

type TagColor =
  | undefined
  | 'primary'
  | 'secondary'
  | 'info'
  | 'success'
  | 'warning'
  | 'danger'
  | 'orange'
  | 'blue'
  | 'green'
  | 'purple'
  | 'white'
  | 'light'
  | 'solid'


export default /*@__PURE__*/_defineComponent({
  __name: 'VTag',
  props: {
  label: {
    type: [String, Number],
    default: undefined,
  },
  color: {
    type: String as PropType<TagColor>,
    default: undefined,
    validator: (value: TagColor) => {
      // The value must match one of these strings
      if (
        [
          undefined,
          'primary',
          'secondary',
          'info',
          'success',
          'warning',
          'danger',
          'orange',
          'blue',
          'green',
          'purple',
          'white',
          'light',
          'solid',
        ].indexOf(value) === -1
      ) {
        console.warn(
          `V-Tag: invalid "${value}" color. Should be primary, secondary, info, success, ` +
            `warning, danger, orange, blue, green, purple, white, light, solid or undefined`
        )
        return false
      }

      return true
    },
  },
  rounded: {
    type: Boolean,
    default: false,
  },
  curved: {
    type: Boolean,
    default: false,
  },
  outlined: {
    type: Boolean,
    default: false,
  },
  elevated: {
    type: Boolean,
    default: false,
  },
  remove: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("small", {
    class: _normalizeClass(["tag", [
      __props.color && 'is-' + __props.color,
      __props.rounded && 'is-rounded',
      __props.curved && 'is-curved',
      __props.outlined && 'is-outlined',
      __props.elevated && 'is-elevated',
      __props.remove && 'is-delete',
    ]])
  }, _toDisplayString(__props.label), 3))
}
}

})